import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tamr-icon-mag-glass",
  "use": "tamr-icon-mag-glass-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"tamr-icon-mag-glass\"><path d=\"M29.7,28.3l-8-8a0.5,0.5,0,0,1,0-.7,11,11,0,1,0-2,2,0.5,0.5,0,0,1,.7,0l8,8A1,1,0,0,0,29.7,28.3ZM13,22a9,9,0,1,1,9-9A9,9,0,0,1,13,22Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol